export const values = [
  {
    id: 1,
    title: '회복',
    subtitle: 'Recovery',
    description: '어려움 속에서도 마음의 균형을 찾아\n건강한 일상으로 나아갈 수 있도록 돕습니다.',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20soft%20green%20organic%20shapes%20flowing%20gently%20like%20leaves%20in%20breeze%2C%20warm%20ivory%20background%2C%20peaceful%20healing%20atmosphere%2C%20minimal%20artistic%20illustration%2C%20nature%20inspired%2C%20soft%20gradients&width=600&height=400&seq=daon-value-01&orientation=landscape',
  },
  {
    id: 2,
    title: '성장',
    subtitle: 'Growth',
    description: '자신을 이해하고 받아들이는 과정을 통해\n더 나은 삶을 향해 성장할 수 있도록 합니다.',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20warm%20orange%20and%20golden%20organic%20curves%20rising%20upward%20like%20growing%20plant%20stems%2C%20ivory%20background%2C%20warmth%20and%20hope%2C%20minimal%20artistic%20illustration%2C%20natural%20growth%20symbolism&width=600&height=400&seq=daon-value-02&orientation=landscape',
  },
  {
    id: 3,
    title: '공감',
    subtitle: 'Empathy',
    description: '누구나 소중한 존재임을 느끼며\n진심 어린 마음으로 함께합니다.',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20soft%20teal%20and%20sage%20organic%20shapes%20intertwining%20gently%2C%20warm%20ivory%20background%2C%20connection%20and%20understanding%2C%20minimal%20artistic%20illustration%2C%20gentle%20harmony%2C%20soft%20textures&width=600&height=400&seq=daon-value-03&orientation=landscape',
  },
  {
    id: 4,
    title: '행복',
    subtitle: 'Happiness',
    description: '작은 변화 속에서도 기쁨을 발견하고\n행복한 삶을 만들어갈 수 있도록 지지합니다.',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20warm%20sunlight%20glow%20with%20soft%20green%20and%20golden%20petals%20floating%20gently%2C%20ivory%20background%2C%20joy%20and%20contentment%2C%20minimal%20artistic%20illustration%2C%20warm%20light%20rays%2C%20serene%20beauty&width=600&height=400&seq=daon-value-04&orientation=landscape',
  },
]

export const activities = [
  {
    id: 1,
    title: '심리상담 지원',
    description: '개인의 마음건강을 돌보는 심리 지원 활동을 통해 내면의 회복과 안정을 돕습니다.',
    image:
      'https://readdy.ai/api/search-image?query=Peaceful%20counseling%20room%20corner%20with%20comfortable%20armchair%20and%20small%20wooden%20side%20table%2C%20soft%20natural%20light%20through%20window%2C%20green%20plant%20in%20ceramic%20pot%2C%20warm%20ivory%20walls%2C%20calm%20professional%20atmosphere%2C%20editorial%20interior%20photography&width=600&height=400&seq=daon-activity-01&orientation=landscape',
  },
  {
    id: 2,
    title: '심리교육 프로그램',
    description: '마음에 대한 이해를 높이고 정서적 역량을 키울 수 있는 다양한 교육 활동을 제공합니다.',
    image:
      'https://readdy.ai/api/search-image?query=Bright%20educational%20space%20with%20open%20books%20on%20wooden%20desk%2C%20notebooks%20and%20pens%20arranged%20neatly%2C%20soft%20natural%20light%2C%20potted%20green%20plants%2C%20ivory%20walls%2C%20warm%20learning%20atmosphere%2C%20editorial%20photography&width=600&height=400&seq=daon-activity-02&orientation=landscape',
  },
  {
    id: 3,
    title: '정서 지원 활동',
    description: '정서적 어려움을 겪는 이들에게 따뜻한 위로와 안정감을 제공하는 지원 활동을 합니다.',
    image:
      'https://readdy.ai/api/search-image?query=Warm%20comforting%20indoor%20space%20with%20soft%20blanket%20on%20couch%2C%20cup%20of%20tea%20on%20table%2C%20gentle%20afternoon%20light%20through%20curtains%2C%20green%20plant%20nearby%2C%20ivory%20and%20warm%20beige%20tones%2C%20cozy%20safe%20atmosphere%2C%20editorial%20photography&width=600&height=400&seq=daon-activity-03&orientation=landscape',
  },
  {
    id: 4,
    title: '지역사회 연계 활동',
    description: '지역사회와 함께 건강한 마음 문화를 만들어가는 다양한 연계 활동을 전개합니다.',
    image:
      'https://readdy.ai/api/search-image?query=Welcoming%20community%20gathering%20space%20with%20round%20wooden%20tables%20and%20chairs%2C%20green%20plants%20scattered%20around%2C%20natural%20light%20from%20large%20windows%2C%20warm%20ivory%20interior%2C%20sense%20of%20connection%20and%20belonging%2C%20editorial%20photography&width=600&height=400&seq=daon-activity-04&orientation=landscape',
  },
]